// apps/client/src/components/XeroSyncPayslips.tsx

import React from 'react';
import { XeroSyncPayslipsResponse, XeroSyncType } from '@avanzu/types';
import { XeroSyncButton } from './XeroSyncButton';

interface XeroSyncPayslipsProps {
  onSyncComplete?: (result: XeroSyncPayslipsResponse) => void;
  variant?: 'contained' | 'outlined' | 'text';
  size?: 'small' | 'medium' | 'large';
  fullWidth?: boolean;
  disabled?: boolean;
  startDate?: Date;
  endDate?: Date;
}

const XeroSyncPayslips: React.FC<XeroSyncPayslipsProps> = (props) => {
  return (
    <XeroSyncButton<XeroSyncPayslipsResponse>
      syncType={XeroSyncType.PAYSLIPS}
      pollInterval={1000}
      {...props}
    />
  );
};

export default XeroSyncPayslips;
